import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IAnnouncementsState {
    isAnnouncementsFinished: boolean
}

const initialState: IAnnouncementsState = {
    isAnnouncementsFinished: false,
}

export const announcementsSlice = createSlice({
    name: 'announcementsSlice',
    initialState,
    reducers: {
        setIsAnnouncementsFinished: (state, action: PayloadAction<{isAnnouncementsFinished: boolean}>) => {
            state.isAnnouncementsFinished = action.payload.isAnnouncementsFinished
        },
    },
})

export const {
  setIsAnnouncementsFinished,
} = announcementsSlice.actions

export default announcementsSlice.reducer
